export const list = {
  input: {
    list_id: {
      label: 'Daftar'
    }
  },

  state: {
    init: {
      description: `
            Daftar nomor - elemen skema yang memungkinkan Anda untuk memfilter panggilan masuk berdasarkan nomor.
            Bergantung pada apakah nomor itu ada di daftar atau tidak, itu akan pergi ke cabang skema perutean yang berbeda.
            Anda dapat menambahkan daftar nomor baru di akun Anda di`
    }
  }
};
